<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { api } from "../../api"

    let dialogElement: HTMLDialogElement

    export function open() {
        dialogElement.showModal()
        getNumbers()
    }

    export function close() {
        dialogElement.close()
    }

    export let showButton = true
    export let cardType: string

    let loading = false
    let numbers: number[]

    async function getNumbers() {
        loading = true
        try {
            const r = await api("action", {
                params: {
                    cmd: "suggestSiids",
                    cardType,
                },
            })
            numbers = r.data?.sportidentIds
        } catch (e) {
            console.error(e)
        }
        loading = false
    }

    // create svelte event dispatcher for number selection
    const dispatch = createEventDispatcher()
</script>

{#if showButton}
    <button class="cta btn-secondary" on:click="{open}"> Suggest Number </button>
{/if}

<dialog class="smooth-shadow border-radius-all border-radius-m" bind:this="{dialogElement}">
    <div class="container">
        <div class="grid justify-center align-center">
            <div class="col-min">
                <h2 class="h3">Suggested SI-Card numbers</h2>
            </div>
            {#if loading}
                <div class="col-12">loading...</div>
            {:else if numbers?.length}
                <div class="col-12 number-suggestions col-grid">
                    {#each numbers as number}
                        <div class="number-suggestion-row">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div
                                role="button"
                                tabindex="0"
                                aria-label="Select this number"
                                class="col-auto"
                                on:click="{() => {
                                    dispatch('selected', number)
                                    close()
                                }}"
                            >
                                {number}
                            </div>
                            <button
                                class="cta btn-tertiary btn-arrow-right"
                                on:click="{() => {
                                    dispatch('selected', number)
                                    close()
                                }}">take this</button
                            >
                        </div>
                    {/each}
                </div>
            {/if}
            <div class="col-min">
                <button class="cta btn-primary" on:click="{close}">Close</button>
            </div>
        </div>
    </div>
</dialog>
